import React from 'react';
export const Button = ({
  children,
  className,
  ...props
}) => {
  return <button className={`px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${className}`} {...props} data-id="element-3677" data-mp="2fy1clideky7p">
      {children}
    </button>;
};